import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { fetchFieldMappingsRequest } from 'modules/catalog/collectionBuilder/actions';
import {
  selectIsProductRecommendationsFeatureFlagOn,
  selectIsUserContextLoaded,
} from 'core/userContext/selectors';
import {
  addSearchGroup,
  changeCombinator,
  initializeQuery,
  moveSearchQuery,
  reorderSearchQuery,
  resetQueryBuilder,
} from '../actions';
import {
  selectCloningValidationMessages,
  selectCombinator,
  selectIsViewMode,
  selectSearchGroups,
} from '../selectors';
import QueryBuilder from './QueryBuilder';

export class QueryBuilderContainer extends React.Component {
  componentWillUnmount = () => {
    this.props.resetQueryBuilder();
  };

  render() {
    return <QueryBuilder {...this.props} />;
  }
}

const mapStateToProps = (state) => ({
  combinator: selectCombinator(state),
  isProductRecommendationsOn: selectIsProductRecommendationsFeatureFlagOn(state),
  isUserContextLoaded: selectIsUserContextLoaded(state),
  isViewMode: selectIsViewMode(state),
  searchGroups: selectSearchGroups(state),
  cloningValidationMessages: selectCloningValidationMessages(state),
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      initializeQuery,
      fetchUserMappings: fetchFieldMappingsRequest,
      onAddSearchGroup: addSearchGroup,
      onChangeCombinator: changeCombinator,
      onSearchQueryMove: moveSearchQuery,
      onSearchQueryReorder: reorderSearchQuery,
      resetQueryBuilder,
    },
    dispatch,
  );

export default connect(mapStateToProps, mapDispatchToProps)(QueryBuilderContainer);
